<template>
    <div class="main main-padding new-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--头部tab及搜索框-->
            <div class="card-header-area">
                <!--tab切换数据-->
                <div class="tab-data">
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
                        <TabPane label="各班级使用产品详情" name="classUserProDetails"></TabPane>
                        <TabPane label="各班级使用产品数据" name="classUserProData"></TabPane>
                    </Tabs>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        :placeholder="placeholder"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--各班级使用产品详情-->
                <div class="table-wrapper-data" v-if="dataIndex==1">
                    <Table :columns="classUseProColumn" :data="classUseProList"></Table>
                </div>
                <!--各班级使用产品数据-->
                <div class="table-wrapper-data" v-if="dataIndex==-1">
                    <Table :columns="classUseProDataColumn" :data="classUseProDataList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {getClassCountData, getDiskIdByCodingKeyList} from "../../../../service/api.js";
    import dateSelect from "../../../../components/dateSelect.vue";

    export default {
        name: "sch-use-pro-details",
        data () {
            return {
                startTime: this.$route.query.startTime,
                schoolId: this.$route.query.schoolId,
                schoolName: this.$route.query.schoolName,
                endTime: this.$route.query.endTime,
                seleStartDate: this.$route.query.seleStartDate,//主页面选择的开始时间
                seleEndDate: this.$route.query.seleEndDate,//主页面选择的结束时间
                diskId: this.$route.query.diskId,
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,
                pageCount: 0,//页数
                placeholder:"支持场景编码、行为编码、创建时间关键字搜索",//提示语
                dataIndex: 1,//默认显示各班级使用产品详情
                classUseProList: [],//各班级使用产品详情
                classUseProDataList: [],//各班级使用产品数据
                classUseProColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户名称",
                        key: "fullName",
                        align: "center",
                    },
                    {
                        title: "场景编码",
                        key: "funcName",
                        align: "center",
                    },
                    {
                        title: "行为编码",
                        key: "clsName",
                        align: "center",
                    },
                    {
                        title: "创建时间",
                        key: "create_time",
                        align: "center",
                    }
                ],
                classUseProDataColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "硬盘ID",
                        key: "disk_id",
                        align: "center",
                    },
                    {
                        title: "场景编码",
                        key: "func_name",
                        align: "center",
                    },
                    {
                        title: "行为编码",
                        key: "clsName",
                        align: "center",
                    },
                    {
                        title: "数量",
                        key: "count",
                        align: "center",
                    }
                ],
            }
        },
        components: {
            //时间选择组件
            dateSelect
        },
        methods: {
            /**
             * 点击tab切换数据信息
             */
            changeDataDetailsIndex (tabsName) {
                //初始化参数
                this.keyWord = "";
                this.page = 1;
                this.total = 0;
                this.pageCount = 0;
                // this.tabsName = tabsName;
                if (tabsName == 'classUserProDetails') {
                    //显示各班级使用产品详情
                    this.dataIndex = 1;
                    this.placeholder="支持场景编码、行为编码、创建时间关键字搜索";
                    this.getClassCountData();
                } else {
                    //显示各班级使用产品数据
                    this.dataIndex = -1;
                    this.placeholder="支持场景编码、行为编码关键字搜索";
                    this.getDiskIdByCodingKeyList();
                }
            },
            /**
             *获取各班级使用产品详情
             */
            async getClassCountData () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startTime,
                    endTime: _this.endTime,
                    diskId: _this.diskId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getClassCountData(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.classUseProList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取各班级使用产品数据
             */
            async getDiskIdByCodingKeyList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startTime,
                    endTime: _this.endTime,
                    diskId: _this.diskId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getDiskIdByCodingKeyList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.classUseProDataList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                if(this.dataIndex==1){
                    this.getClassCountData();
                }else{
                    this.getDiskIdByCodingKeyList();
                }
            },
            /**
             * 翻页
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                if(this.dataIndex==1){
                    this.getClassCountData();
                }else{
                    this.getDiskIdByCodingKeyList();
                }
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "boardMain",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.seleStartDate,
                        endDate: this.seleEndDate,
                    }
                });
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page = 1;
                this.startTime = startDate;
                this.endTime = endDate;
                if(this.dataIndex==1){
                    this.getClassCountData();
                }else{
                    this.getDiskIdByCodingKeyList();
                }
            }
        },
        mounted () {
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            //获取班级安装大屏详情数据
            this.getClassCountData();
            //记住页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.startTime, this.endTime);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .new-data-details {
        .ivu-input-group {
            width: 380px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
